let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iHsNL")).then(() => parcelRequire('51o1K'));